import {
  Box,
  styled,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
} from "@mui/material";
import React from "react";
import { useSearchParams } from "react-router";
import { logger } from "@platform/browser-logger";
import { paletteVar, Typography } from "@platform/design-system";

import { RFPBanner } from "../../components";

const ChecklistHeader = styled(Box)(() => ({
  background: paletteVar("surfaces-neutral", "#f2f2f2"),
  position: "fixed",
  zIndex: 2,
  width: "100%",
}));

export const DocumentChecklist = () => {
  const [params] = useSearchParams();
  const data = params.get("data");
  const json = data ? atob(data) : null;

  if (!json) {
    return (
      <Typography mt={40} variant="header-large">
        No checklist data found
      </Typography>
    );
  }

  const checkListData = JSON.parse(json);

  const documentTypeRow = (coverage) => {
    logger.info(coverage);

    const {
      documentTypeName,
      coverages: { optional, required },
    } = coverage;
    return (
      <TableRow id={documentTypeName}>
        <TableCell>
          <Typography variant="body-medium">
            <strong>{documentTypeName}</strong>
          </Typography>
        </TableCell>
        <TableCell
          sx={{
            background: paletteVar("surfaces-primary", "#EFF8FB"),
          }}
        >
          {required.length ? (
            required.map((item) => (
              <p id={item} key={item}>
                <Typography variant="body-medium">{item}</Typography>
              </p>
            ))
          ) : (
            <p>
              <Typography variant="body-medium">-</Typography>
            </p>
          )}
        </TableCell>
        <TableCell>
          {optional.length ? (
            optional.map((item) => (
              <p id={item} key={item}>
                <Typography variant="body-medium">{item}</Typography>
              </p>
            ))
          ) : (
            <p>
              <Typography variant="body-medium">-</Typography>
            </p>
          )}
        </TableCell>
      </TableRow>
    );
  };

  const coverages = Object.keys(checkListData);

  return (
    <Box mb={5} mt={8}>
      <ChecklistHeader>
        <RFPBanner />
        <Typography variant="header-large" p={3}>
          Required Documents Checklist
        </Typography>
      </ChecklistHeader>
      <Box mt={12} p={3}>
        <Typography variant="body-medium" component="p">
          The following documents are requested based on this RFP&apos;s
          Coverages, Plan Types, and Enrolled Lives in order to satisfy carrier
          requirements for quoting.
        </Typography>
        <Box pt={4}>
          <Table>
            <TableHead
              sx={{
                background: paletteVar("surfaces-neutral", "#f2f2f2"),
              }}
            >
              <TableCell>
                <Typography variant="body-medium">
                  <strong>Document Type</strong>
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body-medium">
                  <strong>
                    Required for Coverages{" "}
                    <Box component="span" sx={{ color: "error.main" }}>
                      *
                    </Box>
                  </strong>
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body-medium">
                  <strong>Optional for Coverages</strong>
                </Typography>
              </TableCell>
            </TableHead>
            <TableBody>
              {coverages.map((coverage) =>
                documentTypeRow(checkListData[coverage]),
              )}
            </TableBody>
          </Table>
        </Box>
      </Box>
    </Box>
  );
};
